var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { strToArrBuf } from 'keystore-idb/utils';
import * as hex from '../common/hex';
import { impl } from '../setup/dependencies';
export var sha256Str = function (str) { return __awaiter(void 0, void 0, void 0, function () {
    var buf, arr, hash;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                buf = strToArrBuf(str, 8);
                arr = new Uint8Array(buf);
                return [4 /*yield*/, impl.hash.sha256(arr)];
            case 1:
                hash = _a.sent();
                return [2 /*return*/, hex.fromBytes(hash)];
        }
    });
}); };
export var hash = {
    sha256: function (bytes) {
        return impl.hash.sha256(bytes);
    },
    sha256Str: sha256Str
};
export var aes = {
    encrypt: function (bytes, key) {
        return impl.aes.encrypt(bytes, key);
    },
    decrypt: function (bytes, key) {
        return impl.aes.decrypt(bytes, key);
    },
    genKeyStr: function () {
        return impl.aes.genKeyStr();
    },
    decryptGCM: function (encrypted, keyStr, ivStr) {
        return impl.aes.decryptGCM(encrypted, keyStr, ivStr);
    }
};
export var rsa = {
    verify: function (message, signature, publicKey) {
        return impl.rsa.verify(message, signature, publicKey);
    }
};
export var ed25519 = {
    verify: function (message, signature, publicKey) {
        return impl.ed25519.verify(message, signature, publicKey);
    }
};
export var keystore = {
    publicReadKey: function () {
        return impl.keystore.publicReadKey();
    },
    publicWriteKey: function () {
        return impl.keystore.publicWriteKey();
    },
    decrypt: function (encrypted) {
        return impl.keystore.decrypt(encrypted);
    },
    sign: function (message, charSize) {
        return impl.keystore.sign(message, charSize);
    },
    importSymmKey: function (key, name) {
        return impl.keystore.importSymmKey(key, name);
    },
    exportSymmKey: function (name) {
        return impl.keystore.exportSymmKey(name);
    },
    keyExists: function (keyName) {
        return impl.keystore.keyExists(keyName);
    },
    getAlg: function () {
        return impl.keystore.getAlg();
    },
    clear: function () {
        return impl.keystore.clear();
    }
};
//# sourceMappingURL=index.js.map